import * as tslib_1 from "tslib";
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Maintenance, UploadCredentialEntityEnum } from '@core/interfaces';
import { UploadService } from '@core/services/upload.service';
import { OnlySpacesValidation } from '@validators/only-spaces';
import { ImportsService } from 'app/main/settings/imports/services/imports.service';
import { chain, isArray, map } from 'lodash';
import moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "../../../../core/authentication/authentication.service";
import * as i2 from "../../../settings/imports/services/imports.service";
import * as i3 from "../../../../core/services/upload.service";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../core/api/maintenances/maintenances.api";
var DialogCreateMaintenancesService = /** @class */ (function () {
    function DialogCreateMaintenancesService(authenticationService, importsService, uploadService, formBuilder, maintenancesApi) {
        this.authenticationService = authenticationService;
        this.importsService = importsService;
        this.uploadService = uploadService;
        this.formBuilder = formBuilder;
        this.maintenancesApi = maintenancesApi;
        this.notContainNumberSignRegex = new RegExp('^[^#]+$');
    }
    DialogCreateMaintenancesService.prototype.createMaintenanceForm = function (params) {
        var maintenanceForm = this.formBuilder.group({
            number: new FormControl(null, [Validators.pattern(this.notContainNumberSignRegex), Validators.maxLength(30)]),
            segment: new FormControl(null, Validators.required),
            company: new FormControl({ value: null, disabled: true }),
            deadlineContract: new FormControl({ value: null, disabled: true }),
            address: new FormControl({ value: null, disabled: true }, Validators.required),
            maintenanceType: new FormControl(null, Validators.required),
            location: new FormControl(null, Validators.required),
            problem: new FormControl({ value: null, disabled: true }),
            message: new FormControl(null, [Validators.required, OnlySpacesValidation.validate]),
            attachments: new FormControl([]),
            equipments: new FormControl([]),
            searchMode: new FormControl('equipment'),
            scheduleSuggestions: new FormArray([]),
            scheduleSuggestionsStatus: new FormControl(null),
            warranties: new FormControl(null),
            previousMaintenanceId: new FormControl(null),
        });
        maintenanceForm.addControl('newEquipments', new FormControl([]));
        maintenanceForm.addControl('locationSectors', new FormControl([]));
        maintenanceForm.addControl('locationEnvironments', new FormControl([]));
        if (params.maintenanceNumberGeneratorType === 'none') {
            maintenanceForm.get('number').setValidators([
                Validators.required,
                Validators.pattern(this.notContainNumberSignRegex), Validators.maxLength(30)
            ]);
            maintenanceForm.get('number').updateValueAndValidity();
        }
        return maintenanceForm;
    };
    DialogCreateMaintenancesService.prototype.toMaintenanceCreateInput = function (params) {
        var value = params.form.getRawValue();
        var input = {
            number: value.number,
            message: value.message,
            attachments: params.attachmentsMapped,
            address: {
                zipCode: value.address.postalCode,
                street: value.address.streetName,
                city: value.address.city,
                number: value.address.number,
                complement: value.address.complement,
                neighborhood: value.address.neighborhood,
                state: value.address.state,
                coords: {
                    latitude: value.address.coords.latitude,
                    longitude: value.address.coords.longitude
                },
            },
            scheduleSuggestions: params.scheduleSuggestionsMapped,
            deadlineContractId: this.toId(value.deadlineContract),
            segmentId: this.toId(value.segment),
            problemId: this.toId(value.problem),
            companyId: this.toId(value.company),
            locationId: this.toId(value.location),
            typeId: this.toId(value.maintenanceType),
            equipmentIds: this.toIds(value.equipments),
            warranties: value.warranties,
            previousMaintenanceId: value.previousMaintenanceId,
        };
        return this.concatSectorsEnvironments({ input: input, value: value });
    };
    DialogCreateMaintenancesService.prototype.toMaintenanceScheduleSuggestionsInput = function (form) {
        var scheduleSuggestions = form.getRawValue().scheduleSuggestions;
        if (!scheduleSuggestions.length) {
            return null;
        }
        return scheduleSuggestions.map(function (suggestion) {
            return {
                date: moment(suggestion.date).set({ hour: 12 }).format('YYYY-MM-DD'),
                time: suggestion.time
            };
        });
    };
    DialogCreateMaintenancesService.prototype.toMaintenanceAttachmentsInput = function (form) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var attachments, result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                attachments = form.getRawValue().attachments;
                if (!attachments.length) {
                    return [2 /*return*/, null];
                }
                result = attachments.map(function (attachment) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var credential;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.importsService.createUploadCredential({
                                    size: attachment.size,
                                    extension: attachment.filename.split('.').pop(),
                                    entity: UploadCredentialEntityEnum.maintenances
                                })];
                            case 1:
                                credential = _a.sent();
                                return [4 /*yield*/, this.uploadService.uploadWithCredentials({
                                        fields: credential.fields,
                                        baseUrl: credential.baseUrl,
                                        file: attachment.file
                                    })];
                            case 2:
                                _a.sent();
                                return [2 /*return*/, {
                                        path: credential.link,
                                        title: attachment.filename
                                    }];
                        }
                    });
                }); });
                return [2 /*return*/, Promise.all(result)];
            });
        });
    };
    DialogCreateMaintenancesService.prototype.hasPreviousMaintenanceWarranties = function (maintenanceForm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, segment, location, maintenanceType, where, result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = maintenanceForm.getRawValue(), segment = _a.segment, location = _a.location, maintenanceType = _a.maintenanceType;
                        if (!segment.id || !location.id || !maintenanceType.id) {
                            return [2 /*return*/, null];
                        }
                        where = {
                            segmentId_in: [segment.id],
                            locationId_in: [location.id],
                            typeId_in: [maintenanceType.id],
                            warrantyStatusIn: ['active', 'extended'],
                            status_in: ['done'
                            ]
                        };
                        return [4 /*yield*/, this.maintenancesApi.search(where, { order: 'asc', orderColumn: 'openedAt', limit: 10 }).toPromise()];
                    case 1:
                        result = _b.sent();
                        if (!result.items.length) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, result.items];
                }
            });
        });
    };
    DialogCreateMaintenancesService.prototype.toId = function (value) {
        return (value && value.id) || null;
    };
    DialogCreateMaintenancesService.prototype.toIds = function (values) {
        return isArray(values) ? map(values, 'id') : null;
    };
    DialogCreateMaintenancesService.prototype.concatSectorsEnvironments = function (params) {
        var e_1, _a, e_2, _b;
        var input = params.input, value = params.value;
        var _c = value.equipments, equipments = _c === void 0 ? [] : _c, _d = value.locationSectors, locationSectors = _d === void 0 ? [] : _d, _e = value.locationEnvironments, locationEnvironments = _e === void 0 ? [] : _e, _f = value.newEquipments, newEquipments = _f === void 0 ? [] : _f;
        var concatLocationEnvironments = locationEnvironments;
        var concatEquipments = chain(equipments).concat(newEquipments).value();
        try {
            for (var concatEquipments_1 = tslib_1.__values(concatEquipments), concatEquipments_1_1 = concatEquipments_1.next(); !concatEquipments_1_1.done; concatEquipments_1_1 = concatEquipments_1.next()) {
                var equipment = concatEquipments_1_1.value;
                if (equipment.locationSector) {
                    locationSectors.push(equipment.locationSector);
                }
                if (equipment.locationEnvironment) {
                    concatLocationEnvironments.push(equipment.locationEnvironment);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (concatEquipments_1_1 && !concatEquipments_1_1.done && (_a = concatEquipments_1.return)) _a.call(concatEquipments_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var concatLocationEnvironments_1 = tslib_1.__values(concatLocationEnvironments), concatLocationEnvironments_1_1 = concatLocationEnvironments_1.next(); !concatLocationEnvironments_1_1.done; concatLocationEnvironments_1_1 = concatLocationEnvironments_1.next()) {
                var locationEnvironment = concatLocationEnvironments_1_1.value;
                if (locationEnvironment.locationSector) {
                    locationSectors.push(locationEnvironment.locationSector);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (concatLocationEnvironments_1_1 && !concatLocationEnvironments_1_1.done && (_b = concatLocationEnvironments_1.return)) _b.call(concatLocationEnvironments_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var equipmentIds = chain(concatEquipments).map('id').uniq().value();
        var locationSectorIds = chain(locationSectors).map('id').uniq().value();
        var locationEnvironmentIds = chain(concatLocationEnvironments).map('id').uniq().value();
        return tslib_1.__assign({}, input, { equipmentIds: equipmentIds,
            locationSectorIds: locationSectorIds,
            locationEnvironmentIds: locationEnvironmentIds });
    };
    DialogCreateMaintenancesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DialogCreateMaintenancesService_Factory() { return new DialogCreateMaintenancesService(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.ImportsService), i0.ɵɵinject(i3.UploadService), i0.ɵɵinject(i4.FormBuilder), i0.ɵɵinject(i5.MaintenancesApi)); }, token: DialogCreateMaintenancesService, providedIn: "root" });
    return DialogCreateMaintenancesService;
}());
export { DialogCreateMaintenancesService };
